import React, { useEffect, useState } from 'react';
import { CircularProgress, Alert, Box } from '@mui/material';
import { PageIndices } from '../../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { EventTypesTab } from '@components/calendar/EventTypesTab.tsx';
import { getCalendarEventTypes } from '@services/calendar.service.ts';
import { CalendarEventType } from '@/types/calendar.ts';

export const AdminEventTypesPage: React.FC = () => {
  const [eventTypes, setEventTypes] = useState<CalendarEventType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getCalendarEventTypes()
      .then(setEventTypes)
      .catch(() => setError('Не вдалося завантажити типи подій'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout>
      <Box data-i-doc={PageIndices.ADMIN_EVENT_TYPES}>
        {loading && <Box display="flex" justifyContent="center" sx={{ mt: 4 }}><CircularProgress /></Box>}
        {error && <Alert severity="error">{error}</Alert>}
        {!loading && !error && <EventTypesTab eventTypes={eventTypes} />}
      </Box>
    </DashboardLayout>
  );
};
